import * as React from 'react';
import Region from '../Region';

interface Props {
  regions: any[];
  onClick: (region: any) => void;
  onOpenEditEntity: (id: string, value: string, type: string) => void;
  onOpenRemoveEntity: (id: string, value: string, type: string) => void;
  isOpenEditPanel: boolean;
}

const Regions: React.FunctionComponent<Props> = ({
  regions,
  onClick,
  onOpenEditEntity,
  onOpenRemoveEntity,
  isOpenEditPanel,
}) => (
  <div>
    {regions.map(region => (
      <Region
        key={region.id}
        region={region}
        onClick={onClick}
        onOpenEditEntity={onOpenEditEntity}
        onOpenRemoveEntity={onOpenRemoveEntity}
        isOpenEditPanel={isOpenEditPanel}
      />
    ))}
  </div>
);

export default Regions;



// WEBPACK FOOTER //
// ./src/scenes/Stores/components/Regions/Regions.tsx